module.exports = __webpack_public_path__ + "static/IMG_0941-734569320a1dfb49cd62f735eb4e4923.jpg";